module.exports = __webpack_public_path__ + "img/placeholder_card.c3ed6e98.svg";